module.exports = __webpack_public_path__ + "img/left_9.69317e07.png";